import script from "./Transfer.vue?vue&type=script&lang=ts"
export * from "./Transfer.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__